var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.appReminder || !_vm.data)?_c('div',{staticClass:"notice-container",style:({ top: _vm.tabBarHeight + _vm.statusBarHeight + 'px' }),on:{"click":_vm.bindToSet}},[_vm._v(" 注意哦！betterWE 检测到系统提醒已关闭，请点击此处设置～ ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }